import { Box } from "@mui/material";
import React from "react";
import SmartCityMap from "./others/SmartCityMap";
import BiciciMap from "./others/BiciciMap";


const PrincipalComponent = () => {
    return(<>
    <Box>
        {/* <SmartCityMap/> */}
        <BiciciMap />
    </Box>
    </>);
}
export default PrincipalComponent;